import type { StepPlanRepetitionMode } from '@az3fr/core';
import { useId } from 'react';

import { LabeledSwitch } from '@/components/ui/labeled-switch';

interface ModeSwitcherProps {
	repetitionMode: StepPlanRepetitionMode;
	onRepetitionModeChange: (repetitionMode: StepPlanRepetitionMode) => void;
	shouldShow: boolean;
	isDisabled: boolean;
	sectionType: string;
}

export function ModeSwitcher({
	repetitionMode,
	onRepetitionModeChange,
	shouldShow,
	isDisabled,
	sectionType,
}: ModeSwitcherProps) {
	const modeSwitcherId = useId();

	if (!shouldShow) {
		return null;
	}

	return (
		<div className="space-y-2">
			<div className="flex items-center justify-between">
				<label
					htmlFor={modeSwitcherId}
					className="font-medium text-gray-500 text-xs uppercase tracking-widest"
				>
					Mode
				</label>
				<LabeledSwitch
					checkedLabel="Custom"
					uncheckedLabel="Template"
					className="text-[0.7rem] [--p:2px] sm:text-xs sm:[--p:3px]"
					onChange={(value: boolean) => onRepetitionModeChange(value ? 'explicit' : 'template')}
					checked={repetitionMode === 'explicit'}
					disabled={isDisabled}
				/>
			</div>
			{isDisabled && (
				<p className="text-amber-600 text-xs">
					Set the number of rounds for this {sectionType} section to enable custom sets
				</p>
			)}
		</div>
	);
}
